import type { AmplifyAppConfig } from "./types.ts";

const REGION = "eu-central-1";
const STAGE = "staging";

export const stagingConfig: AmplifyAppConfig = {
  aws_project_region: REGION,
  aws_cloud_logic_custom: [
    {
      name: "apiFactorsApp",
      endpoint: `https://xtrmk9x8ca.execute-api.${REGION}.amazonaws.com/${STAGE}`,
      region: REGION,
    },
    {
      name: "apiIndicatorApp",
      endpoint: `https://xluy829pdl.execute-api.${REGION}.amazonaws.com/${STAGE}`,
      region: REGION,
    },
    {
      name: "stockpicker",
      endpoint: `https://l21j7vrzbj.execute-api.${REGION}.amazonaws.com/${STAGE}`,
      region: REGION,
    },
  ],
  aws_dynamodb_all_tables_region: REGION,
  aws_dynamodb_table_schemas: [
    { tableName: "CompanyTable-staging", region: REGION },
    { tableName: "IndicatorTable-staging", region: REGION },
    { tableName: "ModelsTable-staging", region: REGION },
    { tableName: "SocketConnectionsTable-staging", region: REGION },
    { tableName: "StrategiesTable-staging", region: REGION },
    { tableName: "Tickers-staging", region: REGION },
    { tableName: "UsersTable-staging", region: REGION },
    { tableName: "UtilityTable-staging", region: REGION },
  ],
};
